import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { initializeMetaPixel } from "./lib/metaPixel";
initializeMetaPixel();
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-140" data-mp="21ck4hpyiy8kf" />);
}